<template>
  <div>
    <div class="element-wrapper">
      <div class="element-box-tp">
        <ul class="NavigationList-styles-navigation-list" v-if="sport">
          <li v-for="s in sortAByKey(sport, 'order').slice(0, 6)">
            <div class="CollapsibleItem-styles-collapsible-item">
              <div class="">
                <div id="1101" class="NavigationItemSimple-styles-navigation-item" @click="collapse(s)">
                  <div class="NavigationItemSimple-styles-container">
                    <img class="NavigationItemSimple-styles-icon" onerror="this.style.display='none'" :src="'/static/assets/img/'+s.alias+'.png'" alt="Fußball" loading="lazy" width="20" height="20">
                    <span class="">
                <a class="" href="javascript:;">{{ s.name }}</a></span></div>
                </div>
              </div>
              <div :class="(s.collapse) ? 'NavigationItem-styles-navigation-item-wrapper' : 'CollapsibleItem-styles-closed NavigationItem-styles-hidden'">

                <ul class="NavigationList-styles-navigation-list">
                  <li v-for="r in sortAByKey(s.region, 'order')">
                    <div class="" @mouseover="hover(r)"
                         @mouseout="unhover(r)">
                      <div class="">
                        <div class="click-area"></div>
                        <div @click="collapseRegion(r)" id="navigation-multi-select-link-30201" class="NavigationItemMultiSelectLink-styles-navigation-item NavigationItemMultiSelectLink-styles-navigation-child-item">
                          <div class="NavigationItemMultiSelectLink-styles-container">
                            <div class="NavigationItemMultiSelectLink-styles-checkbox-container" :class="r.class1">
                              <input type="checkbox" v-model="r.selected" @change="selectedRegion(r.competition, r.regionId)" class="Checkbox-styles-checkbox NavigationItemMultiSelectLink-styles-checkbox" id="30201" readonly="" title="Alles auswählen">
                            </div>
                            <span class="NavigationItemMultiSelectLink-styles-icon flag-ico" :class="'flag-'+r.n.toLowerCase()+' '+r.class1" ></span>
                            <span class="">
                          <a class="" v-tooltip="r.name" v-show="(r.name.length > 10)" href="javascript:;">{{ r.name }}...</a>
                          <a class="" v-show="(r.name.length <= 10)" href="javascript:;">{{ r.name }}</a>
                        </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="NavigationItem-styles-navigation-item-wrapper" v-show="r.collapse">
                      <ul class="NavigationList-styles-navigation-list">
                        <li>
                          <div id="navigation-item-link-42301" class="NavigationItemLink-styles-item">
                            <label class="NavigationItemLink-styles-label">
                              <input type="checkbox" @change="selectedRegion(r.competition, r.regionId)" class="Checkbox-styles-checkbox NavigationItemLink-styles-checkbox" id="42301" readonly="">
                              <a class="NavigationItemLink-styles-title" href="javascript:;">Select All</a>
                              <span class="NavigationItemLink-styles-badge">{{ r.eventCount }}</span></label>
                          </div>
                        </li>
                        <li v-for="c in r.competition">
                          <div id="navigation-item-link-42301" class="NavigationItemLink-styles-item">
                            <div class="clicka" @click="selectedEvent(c.competitionId)"></div>
                            <label class="NavigationItemLink-styles-label">
                              <input type="checkbox" :id="'r'+c.competitionId" value="on"
                                     :class="'competition-checkbox-'+r.regionId" class="Checkbox-styles-checkbox NavigationItemLink-styles-checkbox" readonly=""/>
                              <a class="NavigationItemLink-styles-title">{{ c.name }}</a>
                              <span class="NavigationItemLink-styles-badge">{{ c.eventCount }}</span>
                            </label>
                          </div>
                        </li>
                      </ul>

                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </li>

        </ul>

        <h3 class="Navigation-styles-nav-section-title" id="top-nav-list-title" v-html="(compact) ? t.all : t.all_sports">
        </h3>
        <ul class="NavigationList-styles-navigation-list" v-if="sport">
          <li v-for="s in sortAByKey(sport, 'order').slice(6, sport.length)">
            <div class="CollapsibleItem-styles-collapsible-item">
              <div class="">
                <div id="1101" class="NavigationItemSimple-styles-navigation-item" @click="collapse(s)">
                  <div class="NavigationItemSimple-styles-container">
                    <img class="NavigationItemSimple-styles-icon" onerror="this.style.display='none'" :src="'/static/assets/img/'+s.alias+'.png'" alt="Fußball" loading="lazy" width="20" height="20">
                    <span class="">
                <a class="" href="javascript:;">{{ s.name }}</a></span></div>
                </div>
              </div>
              <div :class="(s.collapse) ? 'NavigationItem-styles-navigation-item-wrapper' : 'CollapsibleItem-styles-closed NavigationItem-styles-hidden'">

                <ul class="NavigationList-styles-navigation-list">
                  <li v-for="r in sortAByKey(s.region, 'order')">
                    <div class="" @mouseover="hover(r)"
                         @mouseout="unhover(r)">
                      <div class="">
                        <div class="click-area"></div>
                        <div @click="collapseRegion(r)" id="navigation-multi-select-link-30201" class="NavigationItemMultiSelectLink-styles-navigation-item NavigationItemMultiSelectLink-styles-navigation-child-item">
                          <div class="NavigationItemMultiSelectLink-styles-container">
                            <div class="NavigationItemMultiSelectLink-styles-checkbox-container" :class="r.class1">
                              <input type="checkbox" v-model="r.selected" @change="selectedRegion(r.competition, r.regionId)" class="Checkbox-styles-checkbox NavigationItemMultiSelectLink-styles-checkbox" id="30201" readonly="" title="Alles auswählen">
                            </div>
                            <span class="NavigationItemMultiSelectLink-styles-icon flag-ico" :class="'flag-'+r.n.toLowerCase()+' '+r.class1" ></span>
                            <span class="">
                          <a class="" v-tooltip="r.name" v-show="(r.name.length > 10)" href="javascript:;">{{ r.name }}...</a>
                          <a class="" v-show="(r.name.length <= 10)" href="javascript:;">{{ r.name }}</a>
                        </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="NavigationItem-styles-navigation-item-wrapper" v-show="r.collapse">
                      <ul class="NavigationList-styles-navigation-list">
                        <li>
                          <div id="navigation-item-link-42301" class="NavigationItemLink-styles-item">
                            <label class="NavigationItemLink-styles-label">
                              <input type="checkbox" @change="selectedRegion(r.competition, r.regionId)" class="Checkbox-styles-checkbox NavigationItemLink-styles-checkbox" id="42301" readonly="">
                              <a class="NavigationItemLink-styles-title">Select All</a>
                              <span class="NavigationItemLink-styles-badge">{{ r.eventCount }}</span></label>
                          </div>
                        </li>
                        <li v-for="c in r.competition">
                          <div id="navigation-item-link-42301" class="NavigationItemLink-styles-item">
                            <div class="clicka" @click="selectedEvent(c.competitionId)"></div>
                            <label class="NavigationItemLink-styles-label">
                              <input type="checkbox" :id="'r'+c.competitionId" value="on"
                                     :class="'competition-checkbox-'+r.regionId" class="Checkbox-styles-checkbox NavigationItemLink-styles-checkbox" readonly=""/>
                              <a class="NavigationItemLink-styles-title">{{ c.name }}</a>
                              <span class="NavigationItemLink-styles-badge">{{ c.eventCount }}</span>
                            </label>
                          </div>
                        </li>
                      </ul>

                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </li>

        </ul>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'topSports',
  data () {
    return {
      t: this.$root.t,
      item: 999999,
      sport: null,
      sport2: null,
      isHovering: [],
      checkBoxClass: {},
      compact: false,
      selectedCompetitions: []
    }
  },
  watch: {
    '$store.state.fixtureTimeperiod' () {
      this.fetchCompetitions();
    }
  },
  mounted () {
    this.fetchCompetitions();

    var th = this
    this.$bus.$on('compact', (payload) => {

      th.compact = payload;

    });
  },
  methods: {
    selectedRegion(competitions, rid){

      Object.values(competitions).forEach(
          val => {
            val.selected = (val.selected) ? false : true;
            this.selectedEvent(val.competitionId)
          }
      )
      //this.selectedEvent()

      //this.CheckUncheckAllAndExcludeDisabledByClass('', 'competition-checkbox-'+rid)

    },
    selectedEvent(e){

      var ina = 'r'+e;

        if(this.selectedCompetitions.includes(e)){
          var index = this.selectedCompetitions.indexOf(e);
          if (index !== -1) {
            this.selectedCompetitions.splice(index, 1);
            document.getElementById(ina).checked = false;
          }
        }else {
          this.selectedCompetitions.push(e);
          document.getElementById(ina).checked = true;

        }

        setTimeout(() => {

          this.$router.replace({name: 'fixture', query: {competition: this.selectedCompetitions} })
        }, 500);


        //this.$bus.$emit('selectedCompetitions', this.selectedCompetitions);
        //this.$store.commit("updateFixtureCompetitions", this.selectedCompetitions);
        //this.$store.commit("updateCompetitionSelect", (this.$store.state.competitionSelect) ? 0 : 1);

    },
    collapse (s) {
      s.collapse = (s.collapse) ? false : true;
    },
    collapseRegion(r) {
      r.collapse = (r.collapse) ? false : true;
      r.class1 = (s.collapse) ? 'NavigationItemMultiSelectLink-styles-is-hovered' : '';
    },
    hover(r){
      r.class1 = 'NavigationItemMultiSelectLink-styles-is-hovered';
    },
    unhover(r){
      r.class1 = '';
    },
    async fetchCompetitions() {

      var th = this;

      this.$http.get(bsapi + 'api/v1/fixture/matches?_=dynamic', {
        params: {
          app: this.$root.app.id,
          withoutMatch: 1,
          per_page: 999999
        }
      }).then(response => {
        // get body data

        th.sport = response.body.result.sport;
        th.sport = Object.values(th.sport);
        th.sport2 = Object.values(th.sport);

        var t = new Date();
        t.setSeconds(t.getSeconds() + 60);

        //window.currentEvents.data = vats;
        //window.currentEvents.time = t.getSeconds();

        if (th.item === 999999) {
          th.$bus.$emit('FixtureEvents', th.sport);
        }

      }, response => {
        th.$bus.$emit('FixtureEvents', null);
      })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.Navigation-styles-nav-section-title {
  font-size: 12px
}

.NavigationItemMultiSelectLink-styles-is-hovered .NavigationItemMultiSelectLink-styles-icon{
  display: none !important;
}
.NavigationItemLink-styles-label {
  margin-bottom: 0px;
}

.NavigationItemMultiSelectLink-styles-icon {
  width: 20px;
  height: 20px;
  top: 0;
  left: 0px;
}

.NavigationItemLink-styles-item {
  position:relative;
  overflow: hidden;
}
.clicka{
  width: 100%;
  height: 100%;
  position: absolute;
  cursor: pointer;
}

.NavigationList-styles-navigation-list {
  margin: 0;
  padding: 0;
  list-style: none
}

.NavigationList-styles-navigation-list-sorted {
  padding: 10px 0 0;
  border-top: 1px solid var(--grey-smoke)
}

.NavigationList-styles-divider {
  width: 100%;
  height: 1px;
  border: 1px solid var(--grey-smoke);
  margin-top: 16px
}

.NavigationList-styles-show-more {
  width: 100%;
  padding: 13px 20px 15px 40px;
  text-align: right;
  border: 0;
  font-family: inherit;
  font-weight: 600;
  font-size: 15px;
  color: var(--black);
  cursor: pointer;
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg height='24' width='24' xmlns='http://www.w3.org/2000/svg'%3E%3CclipPath id='a'%3E%3Cpath clip-rule='evenodd' d='M16.59 8.29L12 12.88 7.41 8.29 6 9.71l6 6 6-6z'/%3E%3C/clipPath%3E%3Cpath d='M16.59 8.29L12 12.88 7.41 8.29 6 9.71l6 6 6-6z' fill='%23b3b3b3' fill-rule='evenodd'/%3E%3Cg clip-path='url(%23a)'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/g%3E%3C/svg%3E") no-repeat 100% 50%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis
}

.NavigationList-styles-show-more:active,
.NavigationList-styles-show-more:focus,
.NavigationList-styles-show-more:hover {
  outline: none
}

.NavigationList-styles-show-more-open {
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg height='24' width='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.4 15.7l4.6-4.6 4.6 4.6 1.4-1.4-6-6-6 6z' fill='%23b3b3b3'/%3E%3C/svg%3E") no-repeat 100% 50%
}

.NavigationList-styles-show-more .NavigationList-styles-show-more-text {
  padding-right: 8px
}

.CollapsibleItem-styles-collapsible-item {
  width: 100%
}

.CollapsibleItem-styles-closed {
  max-height: 0;
  overflow: hidden
}

.NavigationItem-styles-navigation-item-wrapper {
  border-radius: 4px;
  background-clip: padding-box;
  background: var(--grey-snow)
}

.NavigationItem-styles-navigation-item-wrapper.NavigationItem-styles-hidden {
  display: none
}

.NavigationItem-styles-highlighted {
  background-color: var(--white)
}

.NavigationItemLink-styles-item {
  display: flex;
  align-items: center;
  padding: 7px 8px 7px 42px;
  font-size: 13px;
  color: var(--grey-dark)
}

.NavigationItemLink-styles-item label {
  cursor: pointer
}

.NavigationItemLink-styles-item:hover {
  background: var(--white)
}

.NavigationItemLink-styles-item .NavigationItemLink-styles-checkbox {
  height: 14px;
  width: 14px;
  border: 1px solid var(--grey-steel);
  outline: none;
  cursor: pointer;
  margin: 0 16px
}

.NavigationItemLink-styles-item .NavigationItemLink-styles-checkbox:checked {
  border: 1px solid var(--green);
  background: var(--green) url("data:image/svg+xml;charset=utf-8,%3Csvg height='11.42' viewBox='1.73 3.29 14.54 11.42' width='14.54' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.61 14.71L1.73 9.84 3.5 8.07l3.11 3.11 7.89-7.89L16.27 5z' fill='%23fff'/%3E%3C/svg%3E") no-repeat;
  background-size: 10px 7px;
  background-position: 50%
}

.NavigationItemLink-styles-label {
  width: 100%;
  display: flex
}

.NavigationItemLink-styles-title {
  flex: 1
}

.NavigationItemLink-styles-badge {
  margin-left: auto;
  padding-left: 8px;
  color: var(--grey-ash)
}

.Checkbox-styles-checkbox {
  background-color: var(--white);
  border: 1px solid var(--grey-steel);
  border-radius: 2px;
  height: 20px;
  width: 20px;
  vertical-align: middle;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none
}

.Checkbox-styles-checkbox:checked {
  border: 1px solid var(--green);
  background: var(--white) url("data:image/svg+xml;charset=utf-8,%3Csvg height='18' width='18' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.61 14.71L1.73 9.84 3.5 8.07l3.11 3.11 7.89-7.89L16.27 5z' fill='%234ea635'/%3E%3Cpath d='M0 0h18v18H0z' fill='none'/%3E%3C/svg%3E") no-repeat 50%
}

.NavigationItemMultiSelectLink-styles-navigation-item {
  border-radius: 4px;
  background-clip: padding-box;
  display: flex;
  align-items: center;
  padding: 6px 20px;
  font-size: 15px;
  color: var(--black);
  cursor: pointer;
  height: 32px
}

.NavigationItemMultiSelectLink-styles-navigation-item:hover {
  background-color: var(--white)
}

.NavigationItemMultiSelectLink-styles-container {
  position: relative;
  padding-left: 35px
}

.NavigationItemMultiSelectLink-styles-icon {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 15px
}

.NavigationItemMultiSelectLink-styles-icon.NavigationItemMultiSelectLink-styles-is-hovered {
  opacity: 0
}

.NavigationItemMultiSelectLink-styles-checkbox-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  height: 17px;
  width: 17px;
  margin-right: 18px;
  opacity: 0;
  z-index: 1
}

.NavigationItemMultiSelectLink-styles-checkbox-container.NavigationItemMultiSelectLink-styles-is-hovered {
  opacity: 1
}

.NavigationItemMultiSelectLink-styles-checkbox-container .NavigationItemMultiSelectLink-styles-checkbox {
  height: 14px;
  width: 14px;
  border: 1px solid var(--grey-steel);
  outline: none;
  cursor: pointer;
  margin-left: 2px
}

.NavigationItemMultiSelectLink-styles-checkbox-container .NavigationItemMultiSelectLink-styles-checkbox:checked {
  border: 1px solid var(--green);
  background: var(--green) url("data:image/svg+xml;charset=utf-8,%3Csvg height='11.42' viewBox='1.73 3.29 14.54 11.42' width='14.54' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.61 14.71L1.73 9.84 3.5 8.07l3.11 3.11 7.89-7.89L16.27 5z' fill='%23fff'/%3E%3C/svg%3E") no-repeat;
  background-size: 10px 7px;
  background-position: 50%
}

.NavigationItemMultiSelectLink-styles-checkbox-container .NavigationItemMultiSelectLink-styles-checkbox.NavigationItemMultiSelectLink-styles-indeterminate {
  border-color: var(--green);
  border-style: solid;
  border-width: 6px 1px
}

.NavigationItemMultiSelectLink-styles-navigation-child-item {
  padding-left: 40px
}

.NavigationItemMultiSelectLink-styles-navigation-child-item.NavigationItemMultiSelectLink-styles-navigation-item {
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg height='24' width='24' xmlns='http://www.w3.org/2000/svg'%3E%3CclipPath id='a'%3E%3Cpath clip-rule='evenodd' d='M16.59 8.29L12 12.88 7.41 8.29 6 9.71l6 6 6-6z'/%3E%3C/clipPath%3E%3Cpath d='M16.59 8.29L12 12.88 7.41 8.29 6 9.71l6 6 6-6z' fill='%23b3b3b3' fill-rule='evenodd'/%3E%3Cg clip-path='url(%23a)'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/g%3E%3C/svg%3E") no-repeat 100% 50%
}

.NavigationItemMultiSelectLink-styles-navigation-child-item.NavigationItemMultiSelectLink-styles-navigation-item-open {
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg height='24' width='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.4 15.7l4.6-4.6 4.6 4.6 1.4-1.4-6-6-6 6z' fill='%23b3b3b3'/%3E%3C/svg%3E") no-repeat 100% 50%
}

.NavigationItemMultiSelectLink-styles-navigation-child-item.NavigationItemMultiSelectLink-styles-navigation-item:hover {
  background-color: var(--white)
}

.NavigationItemMultiSelectLink-styles-highlighted {
  background-color: var(--white)
}

.NavigationItemSimple-styles-navigation-item {
  border-radius: 4px;
  background-clip: padding-box;
  display: flex;
  align-items: center;
  padding: 6px 15px;
  font-size: 15px;
  color: var(--black);
  cursor: pointer;
  white-space: nowrap
}

.NavigationItemSimple-styles-navigation-item:hover {
  background-color: var(--white)
}

.NavigationItemSimple-styles-container {
  position: relative;
  padding-left: 35px
}

.NavigationItemSimple-styles-icon {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 15px
}

.NavigationItemSimple-styles-navigation-child-item {
  padding-left: 40px
}

.NavigationItemSimple-styles-navigation-child-item.NavigationItemSimple-styles-navigation-item {
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg height='24' width='24' xmlns='http://www.w3.org/2000/svg'%3E%3CclipPath id='a'%3E%3Cpath clip-rule='evenodd' d='M16.59 8.29L12 12.88 7.41 8.29 6 9.71l6 6 6-6z'/%3E%3C/clipPath%3E%3Cpath d='M16.59 8.29L12 12.88 7.41 8.29 6 9.71l6 6 6-6z' fill='%23b3b3b3' fill-rule='evenodd'/%3E%3Cg clip-path='url(%23a)'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/g%3E%3C/svg%3E") no-repeat 100% 50%
}

.NavigationItemSimple-styles-navigation-child-item.NavigationItemSimple-styles-navigation-item-open {
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg height='24' width='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.4 15.7l4.6-4.6 4.6 4.6 1.4-1.4-6-6-6 6z' fill='%23b3b3b3'/%3E%3C/svg%3E") no-repeat 100% 50%
}

.NavigationItemSimple-styles-navigation-child-item.NavigationItemSimple-styles-navigation-item:hover {
  background-color: var(--white)
}

.NavigationItemSimple-styles-highlighted {
  background-color: var(--white)
}
</style>



// WEBPACK FOOTER //
// src/components/stats/widget/sports.vue